import { useRef } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
const DEFAULT_BEHAVIOR = 'smooth';
export const useScrollTo = (offset) => {
    const isScrollingRef = useRef(false);
    const scrollTo = useCallbackRef((element, options) => {
        isScrollingRef.current = true;
        const elementRect = element.getBoundingClientRect();
        const targetY = window.pageYOffset + elementRect.top - offset;
        window.scrollTo({
            top: targetY,
            behavior: options?.behavior ?? DEFAULT_BEHAVIOR,
        });
        const cleanup = () => {
            isScrollingRef.current = false;
        };
        // Listen for scroll end
        if ('onscrollend' in window) {
            document.addEventListener('scrollend', cleanup, { once: true });
        }
        else {
            // Fallback for browsers without scrollend support (use a reasonable timeout)
            setTimeout(cleanup, 1000);
        }
    });
    return { isScrollingRef, scrollTo };
};
